import { useMemo, useState } from 'react';
import MarketingLayout from '../components/marketing/MarketingLayout';
import { faqDe } from '../content/marketing';
import { absolutePublicUrl, buildFaqPageJsonLd } from '../marketing/pageSeo';

export default function MarketingFaqPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faq = faqDe;
  const faqJsonLd = useMemo(
    () => buildFaqPageJsonLd(faq.items, absolutePublicUrl('/support')),
    [faq.items]
  );

  return (
    <MarketingLayout
      title={`${faq.title} | VisiMe`}
      description={faq.description}
      seoPath="/support"
      jsonLd={faqJsonLd}
    >
      <section className="l-page">
        <div className="l-wrap l-page-grid">
          <header className="l-page-head">
            <p className="l-eyebrow">Support</p>
            <h1 className="l-h2">{faq.title}</h1>
            <p className="l-lead">{faq.description}</p>
          </header>
          <div className="l-faq">
            {faq.items.map((item, index) => {
              const open = openIndex === index;
              return (
                <div key={item.question} className="l-faq-item" data-open={open}>
                  <h2>
                    <button type="button" aria-expanded={open} aria-controls={`faq-${index}`} onClick={() => setOpenIndex(open ? null : index)}>
                      <span>{item.question}</span>
                      <i aria-hidden="true" />
                    </button>
                  </h2>
                  <div id={`faq-${index}`} className="l-faq-panel" hidden={!open}>
                    <p>{item.answer}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
